const mainMenuInit = () => {
    var tween = gsap.from(".menu-expanded-content", {
        duration: .3,
        marginLeft: '100vw',
        ease: "none",
        paused: true,
    });
    $('#menu-open-btn').click(() => {
        $('.menu-expanded').addClass('open');
        $('html').addClass('overflow-hidden');
        tween.play();
    });
    $('#menu-close-btn').click(() => {
        setTimeout(() => {
            $('.menu-expanded').removeClass('open');
            $('html').removeClass('overflow-hidden');
        }, 500);
        tween && tween.reverse();
    });
};
const hash = window.location.hash.substr(1);
window.location.hash = "";
const initDownloadLink = () => {
    const sectionPos = Math.round($('#downloads').position()?.left);
    if (location.pathname == '/2020/') {
        if (hash == 'downloads') {
            $('.intro').remove();
            $('html').removeClass('overflow-hidden');
            gsap.to(window, { duration: 2, scrollTo: sectionPos });
        }
    }
    $('#menu_downloads').click((e) => {
        if (location.pathname == '/2020/') {
            e.preventDefault();
            e.stopPropagation();
            $('#menu-close-btn').click();
            gsap.to(window, { duration: 2, scrollTo: sectionPos });
        }
    });
};
$(document).ready(() => {
    mainMenuInit();
    initDownloadLink();
});
//# sourceMappingURL=menu.js.map